/* jQuery is deliberately NOT bundled here. This entry is designed for the
* Phase 2.5 wiring (see docs/vendor-jquery-cleanup-plan.md), where
* functions.php stops deregistering WordPress core's jQuery and 'jquery'
* resolves to core's copy. Until that lands, functions.php still serves the
* old hand-built static/js/vendors.js and this bundle is built but not
* enqueued. This entry only carries the other libraries the theme depends
* on as globals.
*/

/* Angular (+ ngAnimate, ngSanitize, ngStorage)
* ----------------------------------
* static/js/site.js manually bootstraps Angular against window.angular
* (angular.bootstrap(document.getElementById('ng-app'), ['uniavis'])) and
* declares 'ngAnimate'/'ngStorage'/'ngSanitize' as module deps - it's the
* entire implementation of the cookie banner, newsletter form, nav, sliders,
* page-progress, search, event archive, and timeago. angular-touch/ngTouch
* is not used anywhere and is deliberately not included here.
* Angular must attach to window before the sub-modules load - they patch
* the existing window.angular rather than requiring their own copy.
*/
window.angular = require('angular');
require('angular-animate');
require('angular-sanitize');
require('ngstorage');

/* GSAP (TweenLite/TweenMax/TimelineLite/TimelineMax + core plugins)
* ----------------------------------
*/
var gsap = require('gsap/TweenMax');
window.TweenLite = gsap.TweenLite;
window.TweenMax = gsap.TweenMax;
window.TimelineLite = gsap.TimelineLite;
window.TimelineMax = gsap.TimelineMax;
// gsap/TweenMax bundles CSS/Attr/RoundProps/DirectionalRotation/Bezier
// plugins but NOT ScrollToPlugin. static/js/site.js uses
// TweenMax.to(window, ..., {scrollTo: ...}) for back-to-top, anchor and
// factbox scrolling, and the old hand-built bundle shipped the plugin -
// without it those tweens silently no-op. Requiring it registers
// 'scrollTo' on the shared TweenLite instance.
require('gsap/ScrollToPlugin');

/* Swiper
* ----------------------------------
* static/js/site.js's sliderWrapper component (the ACF Gallery module) calls
* new Swiper('.swiper-container', ...) and expects a global. Pinned to the 3.x
* line the old hand-built bundle shipped (3.4.2): Swiper 4+ changed the
* options API (nextButton/prevButton/pagination/paginationType/keyboardControl
* became nested navigation/pagination/keyboard objects) and its DOM class
* names, so upgrading is a site.js + SCSS change, not a bundle bump.
*/
window.Swiper = require('swiper');

/* Lodash
* ----------------------------------
*/
window._ = require('lodash');

/* Moment
* ----------------------------------
*/
window.moment = require('moment');

/* lazysizes
* ----------------------------------
* Self-initializes against [data-src]/[data-srcset] on import, no global
* assignment needed (used by modules/Image.php, modules/MultiImage.php).
*/
require('lazysizes');
